import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <article className="group relative bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]">
      <Link to={`/article/${comic.id}`} className="block">
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={comic.comic
            }
            alt={comic.title}
            title={`${comic.title} - 韩漫漫画网免费在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute top-2 left-2">
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
              comic.status === "连载中"
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-500 text-background-50"
            }`}>
              {comic.status}
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <p className="text-background-50 text-xs line-clamp-2">{comic.description}</p>
          </div>
        </div>
        <div className="p-3">
          <h3 className="font-heading font-semibold text-foreground-900 text-sm truncate group-hover:text-primary-500 transition-colors duration-200">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center gap-1">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-700 font-medium">{comic.rating}</span>
            </div>
            <span className="text-xs text-foreground-400">
              {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views} 阅读
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}